module.exports = __webpack_public_path__ + "static/img/avatar-right.42b4fd80.png";